import { useFilter } from '@innovyze/map-components';
import { useIsFeatureEnabled } from '@innovyze/stylovyze/lib/utils/features';

export const usePolygonTool = () => {
	const isPolygonToolEnabled = !!useIsFeatureEnabled(
		'i-360-release-142071-polygon-filter-for-data-grid',
	);
	const { setPolygonFilter } = useFilter();

	return {
		isPolygonToolEnabled,
		setPolygonFilter: isPolygonToolEnabled ? setPolygonFilter : undefined,
	};
};
